import { render, staticRenderFns } from "./suggest-details.vue?vue&type=template&id=6b97db2f&scoped=true&"
import script from "./suggest-details.vue?vue&type=script&lang=js&"
export * from "./suggest-details.vue?vue&type=script&lang=js&"
import style0 from "./suggest-details.vue?vue&type=style&index=0&id=6b97db2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b97db2f",
  null
  
)

export default component.exports